/** 実況ログの表示（docs/06_ui-ux.md 7 章）。P0 はシステムメッセージだけ流す */
import { el } from '../layout';

export type LogSpeaker = 'system' | 'announcer' | 'commentator' | 'rival' | 'viewer';

const SPEAKER_LABEL: Record<LogSpeaker, string> = {
  system: 'システム',
  announcer: '実況',
  commentator: '解説',
  rival: '',
  viewer: '',
};

const MAX_ITEMS = 200;

export function createLogView(host: HTMLElement): {
  add(speaker: LogSpeaker, text: string, name?: string): void;
} {
  const head = el('div', 'log__head');
  head.append(el('span', 'log__live', 'LIVE'), el('span', 'log__title', 'レース実況'));
  const list = el('ol', 'log__list');
  host.append(head, list);
  let hovering = false;
  list.addEventListener('mouseenter', () => (hovering = true));
  list.addEventListener('mouseleave', () => (hovering = false));

  return {
    add(speaker, text, name) {
      const li = el('li', `log__item log__item--${speaker}`);
      const badge = name ?? SPEAKER_LABEL[speaker];
      if (badge) li.appendChild(el('span', 'log__badge', badge));
      li.appendChild(el('span', 'log__text', text));
      list.appendChild(li);
      while (list.childElementCount > MAX_ITEMS) list.firstElementChild?.remove();
      if (!hovering) list.scrollTop = list.scrollHeight;
    },
  };
}
